import { z } from 'zod';

import {
  b2cNonProdLaunchedCountryCodes,
  b2cProdLaunchedCountryCodes,
  countryMap,
} from '@Common/countries';

export type CountryCode = keyof typeof countryMap;

export const ZodTaxResidenceCodeProd = z.enum([
  b2cProdLaunchedCountryCodes[0],
  ...b2cProdLaunchedCountryCodes,
]);
export const ZodTaxResidenceCodeNonProd = z.enum([
  b2cNonProdLaunchedCountryCodes[0],
  ...b2cNonProdLaunchedCountryCodes,
]);
